import { observable, action } from 'mobx'
import { actionBase } from 'wbap-core-commit'

class Model extends actionBase {

  constructor (appInfo, props) {
    super(appInfo)
    this.appInfo = appInfo
    this.props = props
  }

  @observable
  data = {
    type: 'account'
  }

  /**
   * 切换登录方式
   * @param _type 登录方式 account:用户名密码, mobile:手机号验证码
   */
  @action onTabChange = (_type) => {
    this.data.type = _type
  }

  /**
   * 登录
   * @param _err 是否存在错误
   * @param _values 提交的登录信息
   */
  onLogin = (_err, _values) => {
    if (!_err) {
      this.actQuery.selectParam.clear()
      this.actQuery.selectParam.set('FCODE', _values.FCODE)
      this.actQuery.selectParam.set('FKEY', _values.FPASSWORD)
      this.actQuery.execute()
    }
  }

  /**
   * 判断登录是否成功
   * @param target
   */
  actQuery_onAfterExecute (target) {
    super.actQuery_onAfterExecute(target)
    const userData = this.model.tableJson('{E301E073-F0C0-42C8-9D92-D21DA58B9F40}')
    if (userData.length === 0) {
      this.toast('error', '用户不存在!')
    } else {
      if (userData[0].FRESULT === '0') {
        this.toast('error', '密码错误,请核对密码!')
      } else {
        this.setGlobalInfo(userData[0])
        if (this.model.UserStore.FUSER_ID) {
          this.model.RouterStore.history.replace('/')
        }
      }
    }
  }

  @action setGlobalInfo (userData) {
    this.model.UserStore.FUSER_ID = userData.FMID || ''
    this.model.UserStore.FUSER_CODE = userData.FCODE || ''
    this.model.UserStore.FUSER_NAME = userData.FNAME || ''
    this.model.UserStore.FUSER_IMG = ''
    this.model.UserStore.FORG_ID = userData.FORGID || ''
    this.model.UserStore.FORG_CODE = userData.FORGCODE || ''
    this.model.UserStore.FORG_NAME = userData.FORGNAME || ''
  }
}

export default Model




// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-login/model.js